import { UserRole } from '~/types/user'
import { FEATURES_OFF, disabledFeatureForPage } from '~/utils/featureFlags'

export default defineNuxtRouteMiddleware(async (to, from) => {
    const user = await useAuthStore().setUser()
    if (!user) {
        return navigateTo('/login')
    }

    if (disabledFeatureForPage(to.path, user.features ?? FEATURES_OFF)) {
        return navigateTo('/')
    }

    const home = user.role === UserRole.fieldMedic ? '/field-posts' : '/'
    if (to.path === '/' && home !== '/') {
        return navigateTo(home)
    }

    const roles = (to.meta.roles as UserRole[]) || []
    if (roles.length && !roles.includes(user.role)) {
        return navigateTo(home)
    }
})
